import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { MunicipalHearing } from 'types/Documents';

export const useMunicipalHearing = (id: string | null) =>
  useDocumentDetails<Document<MunicipalHearing> | null>(id);
